// actionTypes.js
export const SET_VALUE_INVESTISSEMENT = 'SET_VALUE_INVESTISSEMENT';
export const SET_STATUT_INVESTISSEMENT = 'SET_STATUT_INVESTISSEMENT';
export const SET_ClASSE_IMMOBILISATION = 'SET_ClASSE_IMMOBILISATION';
export const SET_CURRENT_PAGE_INVESTISSEMENT = 'SET_CURRENT_PAGE_INVESTISSEMENT';
export const SET_ORDER_INVESTISSEMENT = 'SET_ORDER_INVESTISSEMENT';
export const SET_SORT_FIELD_INVESTISSEMENT = 'SET_SORT_FIELD_INVESTISSEMENT';

